<template>
    <div class="vue-need-bootstrap h100">
        <div class="d-flex justify-content-center align-items-center w-100 h-100 gradient-customily-bg">
            <b-card>
                <b-card-body>
                    <b-row>
                        <b-col>
                            <img class="center-block" :src="customilyImg" />

                            <div v-if="username && token && !errorMessage">
                                <div v-show="!emailConfirmed">
                                    <b-card-text class="mt-2"> Confirming your new email address </b-card-text>

                                    <div class="text-center mt-2">
                                        <b-spinner variant="primary" class="mr-2" />
                                    </div>
                                </div>

                                <div v-show="emailConfirmed" class="mt-3">
                                    <b>{{ confirmedEmail }}</b> was confirmed for your user {{ confirmedUsername }}
                                </div>
                            </div>

                            <div v-if="!username || !token">
                                <b-card-text class="text-center mt-2"> Invalid URL </b-card-text>
                            </div>

                            <div v-if="errorMessage" class="text-center mt-2">
                                <b-card-text class="mb-2"> Error confirming email address </b-card-text>
                                <b-card-text class="error-message">
                                    {{ errorMessage }}
                                </b-card-text>
                            </div>
                        </b-col>
                    </b-row>
                </b-card-body>
            </b-card>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { Ref, computed, onMounted, ref } from 'vue';
import { confirmEmail } from '@/api/user';
import { AxiosError } from 'axios';

const username: Ref<string | null> = ref(null);
const token: Ref<string | null> = ref(null);
const errorMessage: Ref<string | null> = ref(null);

const emailConfirmed = ref(false);
const confirmedEmail: Ref<string | null> = ref(null);
const confirmedUsername: Ref<string | null> = ref(null);

const customilyImg = computed(() => {
    return require('@/angular-app/images/signInLogo.png');
});

onMounted(async () => {
    const url = new URL(location.href);
    username.value = url.searchParams.get('user');
    token.value = url.searchParams.get('token');

    if (!username.value || !token.value) return;
    try {
        const response = await confirmEmail(username.value, token.value);
        confirmedEmail.value = response.Email;
        confirmedUsername.value = response.Username;
        emailConfirmed.value = true;
    } catch (error) {
        const axiosError = error as AxiosError;
        if (axiosError.response?.status === 400) {
            if (axiosError.response.data.Message) {
                errorMessage.value = axiosError.response.data.Message;
            }
        } else {
            errorMessage.value = 'Fatal error';
            window.rumReportError(axiosError);
        }
    }
});
</script>
